import { render, staticRenderFns } from "./ProjectsPanelBlankSlate.vue?vue&type=template&id=2d9027c5&"
import script from "./ProjectsPanelBlankSlate.vue?vue&type=script&lang=js&"
export * from "./ProjectsPanelBlankSlate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports